import React from 'react';
import logo from '../../../images/blog-logo.png';

const LogoTitle = () => {
    return (
        <div className='ps-3 mt-2 d-flex flex-wrap gap-2 align-items-center justify-content-start'>
            <img src={logo} alt="Logo" className='rounded-circle border border-3' />
            <div className='text-start d-flex flex-column'>
                <p className='m-0 text-success fw-semibold'>Crescent Partha</p>
                <div className='d-flex flex-wrap align-items-center justify-content-start'>
                    <span className='me-4'>September 12, 2022</span>
                    <span>5 mins</span>
                </div>
            </div>
        </div>
    );
};

export default LogoTitle;